module.exports = __webpack_public_path__ + "static/media/1915_porta_casa_di_Pieve_di_Soligo.ccbe57bc.jpg";